import * as types from './action-types';
import {CurrenciesService} from 'frilans-finans';

const setCurrencies = (currencies, error = false) => {
  return {
    type: types.SET_CURRENCIES,
    payload: currencies
  };
};

export const fetchCurrencies = () => {
  return (dispatch) => {
    dispatch({type: types.FETCH_CURRENCIES});

    CurrenciesService.get()
      .then((currencies) => {
        dispatch({type: types.FETCH_CURRENCIES_SUCCESS});
        dispatch(setCurrencies(currencies.collection));
      })
      .catch((error) => {
        dispatch({type: types.FETCH_CURRENCIES_FAIL});
        dispatch({type: types.ERROR_CURRENCIES, error});
      });
  };
};



/** WEBPACK FOOTER **
 ** ./src/redux/modules/currencies/index.js
 **/